"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SapphireCoreStorageFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var SapphireCoreStorageFactory = /** @class */ (function (_super) {
    __extends(SapphireCoreStorageFactory, _super);
    function SapphireCoreStorageFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    SapphireCoreStorageFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    SapphireCoreStorageFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    SapphireCoreStorageFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    SapphireCoreStorageFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    SapphireCoreStorageFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return SapphireCoreStorageFactory;
}(contracts_1.ContractFactory));
exports.SapphireCoreStorageFactory = SapphireCoreStorageFactory;
var _abi = [
    {
        inputs: [],
        name: "BASE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "assessor",
        outputs: [
            {
                internalType: "contract ISapphireAssessor",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "borrowFee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "borrowIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "borrowPool",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "collateralAsset",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultBorrowLimit",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "expectedEpochWithProof",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "feeCollector",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "highCollateralRatio",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "indexLastUpdate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "interestRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "interestSetter",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "liquidationArcFee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "liquidatorDiscount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lowCollateralRatio",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "normalizedTotalBorrowed",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "oracle",
        outputs: [
            {
                internalType: "contract ISapphireOracle",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pauseOperator",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "poolInterestFee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "precisionScalars",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "vaultBorrowMaximum",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "vaultBorrowMinimum",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "vaults",
        outputs: [
            {
                internalType: "uint256",
                name: "collateralAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "normalizedBorrowedAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "principal",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "0x608060405234801561001057600080fd5b506103b6806100206000396000f3fe608060405234801561001057600080fd5b50600436106101735760003560e01c8063867e5cb8116100de578063bf39f57711610097578063e61c6dee11610071578063e61c6dee14610328578063e626648a14610331578063ec342ad01461033a578063fe02a7ab1461034957600080fd5b8063bf39f57714610303578063c3f323501461030c578063c415b95c1461031557600080fd5b8063867e5cb814610283578063a622ee7c1461028c578063aa5af0fd146102d5578063aabaecd6146102de578063af3b334f146102f1578063beb2cbe3146102fa57600080fd5b80635c975abb116101305780635c975abb1461020e57806363f07eef1461022b5780636af5c0b21461023457806373cc42e5146102545780637c3a00fd146102675780637dc0d1d01461027057600080fd5b80631821d696146101785780631db1660a146101a8578063225c049b146101bf578063291cc98a146101df57806343b72d0d146101e85780634afdcbde146101fb575b600080fd5b60075461018b906001600160a01b031681565b6040516001600160a01b0390911681526020015b60405180910390f35b6101b160025481565b60405190815260200161019f565b6101b16101cd366004610352565b60186020526000908152604090205481565b6101b160035481565b60135461018b906001600160a01b031681565b60145461018b906001600160a01b031681565b60005461021b9060ff1681565b604051901515815260200161019f565b6101b160125481565b6101b1610242366004610352565b600a6020526000908152604090205481565b600c5461018b906001600160a01b031681565b6101b160115481565b60095461018b906001600160a01b031681565b6101b160045481565b6102ba61029a366004610352565b600160208190526000918252604090912080549181015460029091015483565b6040805193845260208401929092529082015260600161019f565b6101b1600f5481565b600b5461018b906001600160a01b031681565b6101b160055481565b6101b160105481565b6101b160155481565b6101b160165481565b60085461018b906001600160a01b031681565b6101b160175481565b6101b160065481565b6101b1670de0b6b3a764000081565b6101b1600e5481565b600060208284031215610363578081fd5b81356001600160a01b0381168114610379578182fd5b939250505056fea2646970667358221220674f0ef3dddebc1e8fc667f6868c941a066f87886a61b624c9e3714fa5c164f964736f6c63430008040033";
